import { Component, inject, signal } from '@angular/core';
import { arabicNameValidators, optionalName } from '../../../../validators/name-rules';
import { SuppliersService } from '../../../../services/suppliers/suppliers.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-admin-add-supplier-component',
  imports: [ReactiveFormsModule],
  templateUrl: './admin-add-supplier-component.html',
  styleUrl: './admin-add-supplier-component.scss',
})
export class AdminAddSupplierComponent {
  private suppliersService = inject(SuppliersService);
  private router = inject(Router);

  loading = signal<boolean>(false);
  errorCreatingSupplier = signal<string | null>(null);

  formSubmitted = false;

  supplierForm = new FormGroup({
    titleEn: new FormControl('', [Validators.minLength(2), Validators.maxLength(100)]),
    titleAr: new FormControl('', arabicNameValidators(100)),
  });

  ngOnInit() {}

  onSubmit() {
    this.formSubmitted = true;

    if (this.supplierForm.invalid) {
      for (const key in this.supplierForm.controls) {
        this.supplierForm.get(key)?.markAsTouched();
      }
      return;
    }

    this.loading.set(true);
    this.errorCreatingSupplier.set(null);

    const formValue = this.supplierForm.getRawValue();
    const payload = {
      titleEn: optionalName(formValue.titleEn),
      titleAr: formValue.titleAr!.trim(),
    };

    this.suppliersService.createSupplier(payload).subscribe({
      next: () => {
        this.loading.set(false);
        this.router.navigate(['/admin/suppliers']);
      },
      error: (err) => {
        console.error('Error creating supplier:', err);
        this.loading.set(false);
        this.errorCreatingSupplier.set('Failed to create suppler. Please try again.');
      },
    });
  }

  onCancel() {
    this.router.navigate(['/admin/suppliers']);
  }
}
